"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Victim service.
* @module api/VictimApi
* @version 1.0.0
*/
var VictimApi = /*#__PURE__*/function () {
  /**
  * Constructs a new VictimApi. 
  * @alias module:api/VictimApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function VictimApi(apiClient) {
    _classCallCheck(this, VictimApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * list victims
   * @param {Object} opts Optional parameters
   * @param {Number} opts.page 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(VictimApi, [{
    key: "apiV1VictimsGetWithHttpInfo",
    value: function apiV1VictimsGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list victims
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsGet",
    value: function apiV1VictimsGet(opts) {
      return this.apiV1VictimsGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update victim
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsIdPatchWithHttpInfo",
    value: function apiV1VictimsIdPatchWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1VictimsIdPatch");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims/{id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update victim
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsIdPatch",
    value: function apiV1VictimsIdPatch(id) {
      return this.apiV1VictimsIdPatchWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update victim
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsIdPutWithHttpInfo",
    value: function apiV1VictimsIdPutWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1VictimsIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update victim
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsIdPut",
    value: function apiV1VictimsIdPut(id) {
      return this.apiV1VictimsIdPutWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * new_victims victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsNewVictimsGetWithHttpInfo",
    value: function apiV1VictimsNewVictimsGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims/new_victims', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * new_victims victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsNewVictimsGet",
    value: function apiV1VictimsNewVictimsGet() {
      return this.apiV1VictimsNewVictimsGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * create victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsPostWithHttpInfo",
    value: function apiV1VictimsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsPost",
    value: function apiV1VictimsPost() {
      return this.apiV1VictimsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * todays_rememberances victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsTodaysRememberancesGetWithHttpInfo",
    value: function apiV1VictimsTodaysRememberancesGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims/todays_rememberances', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * todays_rememberances victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsTodaysRememberancesGet",
    value: function apiV1VictimsTodaysRememberancesGet() {
      return this.apiV1VictimsTodaysRememberancesGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * upcomming_anniversaries victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1VictimsUpcommingAnniversariesGetWithHttpInfo",
    value: function apiV1VictimsUpcommingAnniversariesGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/victims/upcomming_anniversaries', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * upcomming_anniversaries victim
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1VictimsUpcommingAnniversariesGet",
    value: function apiV1VictimsUpcommingAnniversariesGet() {
      return this.apiV1VictimsUpcommingAnniversariesGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return VictimApi;
}();

exports.default = VictimApi;